import { render, staticRenderFns } from "./Sale.vue?vue&type=template&id=2549a381&scoped=true&"
import script from "./Sale.vue?vue&type=script&lang=js&"
export * from "./Sale.vue?vue&type=script&lang=js&"
import style0 from "./Sale.vue?vue&type=style&index=0&id=2549a381&prod&lang=css&"
import style1 from "./Sale.vue?vue&type=style&index=1&id=2549a381&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2549a381",
  null
  
)

export default component.exports